module.exports = __webpack_public_path__ + "img/17.f40e5023.png";